import { getMeridianStatus } from '../getMeridianStatus';

const meridianToMilitary = (meridianTime: string): string => {
  const { isAm, isMeridian, isPm } = getMeridianStatus(meridianTime);
  const [hour, min, second] = meridianTime.split(':').map((timeChunk) => parseInt(timeChunk));
  if (!isMeridian) console.log(`Time passed was not meridian time: ${meridianTime}`);
  let finalHour = hour;
  if (isPm && finalHour < 12) {
    finalHour += 12;
  }
  if (isAm && hour === 12) {
    finalHour = 0;
  }
  const finalSecond = second ? `:${second}` : '';
  return `${finalHour < 10 ? `0${finalHour}` : finalHour}:${min < 10 ? `0${min}` : min}${finalSecond}`;
};

export default meridianToMilitary;
